import { useEffect, useRef, useState } from "react";
import IconButton from "../IconButton/IconButton";
import tokens from "../../tokens";
import styles from "./dropdownMenu.css";
import { DropdownMenuContext } from "./DropdownMenuContext.jsx";

function DropdownMenu({
  direction,
  openIcon = "more",
  closedIcon = "more",
  theme = "light",
  children,
}) {
  const [open, setOpen] = useState(false);
  const menuRef = useRef();

  useEffect(() => {
    function handleEscapeDown(e) {
      if (e.key === "Escape") {
        setOpen(false);
      }
    }

    function handleOutsideClick(e) {
      if (open && menuRef.current && !menuRef.current.contains(e.target)) {
        setOpen(false);
      }
    }

    if (open) {
      document.addEventListener("keydown", handleEscapeDown);
      document.addEventListener("click", handleOutsideClick);
    }

    return () => {
      document.removeEventListener("keydown", handleEscapeDown);
      document.removeEventListener("click", handleOutsideClick);
    };
  }, [open]);

  function handleToggle(e) {
    // prevents the 'handleOutsideClick' event to trigger
    e.stopPropagation();

    setOpen((current) => !current);
  }

  const icon = open ? closedIcon : openIcon;

  return (
    <div ref={menuRef} className={styles.container({ theme })}>
      <IconButton
        name={icon}
        size={tokens.space["3x"]}
        onClick={handleToggle}
        theme={theme}
      />
      <DropdownMenuContext.Provider value={{ open: open, setOpen: setOpen }}>
        <menu className={styles.dropdownMenu({ open, direction })}>
          {children}
        </menu>
      </DropdownMenuContext.Provider>
    </div>
  );
}

export default DropdownMenu;
